import React from 'react';
import { LoanInfo, ApprovalHistory } from "../../../components";

function Index({ loan }) {

    return (
        <div className="space-y-5 py-4">

            {/* History */}
            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
                <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700">
                    <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">History</h4>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full">
                        <thead>
                            <tr className="border-b border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/60">
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide w-[20%]">Admin</th>
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide w-[12%]">Action</th>
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide w-[53%]">Comments</th>
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide w-[15%]">Date</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                            {loan?.history && loan?.history.length > 0 ?
                                loan.history.map((item, index) => (
                                    <ApprovalHistory key={index} item={item} />
                                ))
                            :
                                <tr>
                                    <td colSpan={4} className="px-5 py-10 text-center text-sm text-gray-400">
                                        No history yet.
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Application Details */}
            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
                <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700">
                    <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">Application Details</h4>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full">
                        <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                            <LoanInfo loan={loan} />
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
}

export default Index;
